// @ts-nocheck
import React from 'react';
import { StyleSheet, View } from 'react-native';
import { Card, Menu } from 'react-native-paper';
import Text from '../../../components/Text';
import IconButton from '../../../components/IconButton';
import { Delivery } from '../../../@types';
import {
  deriveDisplayName,
  getCurrentUnitLink,
} from '../../../utils';
import {getDeliveryPermissions} from '../permissions';
import Ionicons from '@expo/vector-icons/Ionicons';
import Feather from '@expo/vector-icons/Feather';

function getCategoryIcon(category?: string): string | null {
  if (!category) return null;
  const cat = category.toLowerCase();
  if (cat.includes('food') || cat.includes('meal') || cat.includes('restaurant')) return 'coffee';
  if (cat.includes('grocery') || cat.includes('supermarket') || cat.includes('shopping')) return 'shopping-bag';
  if (cat.includes('mail') || cat.includes('letter') || cat.includes('post')) return 'mail';
  if (cat.includes('package') || cat.includes('parcel') || cat.includes('box')) return 'box';
  if (cat.includes('water') || cat.includes('beverage')) return 'droplet';
  if (cat.includes('gas') || cat.includes('fuel')) return 'zap';
  if (cat.includes('service') || cat.includes('maintenance') || cat.includes('repair')) return 'wrench';
  return null;
}

export default function DeliveryItem({
  delivery,
  onSelectEdit,
  onSelectDelete,
  itemClickHandler,
}: {
  delivery: Delivery;
  itemClickHandler: () => void;
  onSelectDelete: () => void;
  onSelectEdit: () => void;
}) {
  const [menuVisible, setMenuVisible] = React.useState(false);
  const deliveryDate = delivery?.dateFrame?.startDate
    ? new Date(delivery.dateFrame.startDate).toLocaleDateString()
    : 'Date not provided';

  const currentUnitLink = getCurrentUnitLink();
  const deliveryPermissions = getDeliveryPermissions(
    currentUnitLink?.deliveryPermission,
  );
  const categoryIcon = getCategoryIcon(delivery.category);

  return (
    <Card style={styles.card} onPress={() => itemClickHandler()}>
      <View style={styles.container}>
        {/* Header row: category badge + company name + date & action */}
        <View style={styles.headerRow}>
          <View style={styles.titleBlock}>
            <View style={styles.typeBadge}>
              {!!categoryIcon && <Feather name={categoryIcon} size={11} color="#6366f1" />}
              <Text style={styles.typeBadgeText}>
                {delivery.category ? delivery.category : 'DELIVERY'}
              </Text>
            </View>
            <Text numberOfLines={1} style={styles.companyText}>
              {delivery.company ? delivery.company : 'Company not provided'}
            </Text>
          </View>
          <View style={styles.rightActionRow}>
            {deliveryPermissions.canEdit || deliveryPermissions.canDelete ? (
              <View style={styles.menuContainer}>
                <Menu
                  visible={menuVisible}
                  onDismiss={() => setMenuVisible(false)}
                  anchor={
                    <IconButton
                      icon="ellipsis-vertical"
                      size={18}
                      iconColor={'#71717a'}
                      onPress={() => setMenuVisible(true)}
                    />
                  }>
                  {deliveryPermissions.canEdit && (
                    <Menu.Item
                      onPress={() => {
                        setMenuVisible(false);
                        onSelectEdit();
                      }}
                      title="Edit"
                    />
                  )}
                  {deliveryPermissions.canDelete && (
                    <Menu.Item
                      onPress={() => {
                        setMenuVisible(false);
                        onSelectDelete();
                      }}
                      title="Delete"
                    />
                  )}
                </Menu>
              </View>
            ) : (
              <Feather name="chevron-right" size={18} color="#a1a1aa" />
            )}
          </View>
        </View>

        {/* Metadata detail rows with icons */}
        <View style={styles.metaContainer}>
          <View style={styles.metaRow}>
            <Feather name="user" size={12} color="#71717a" />
            <Text numberOfLines={1} style={styles.metaText}>
              {`By ${deriveDisplayName(delivery?.personAuthorizing)}`}
            </Text>
          </View>
          <View style={styles.metaRow}>
            <Feather name="calendar" size={12} color="#71717a" />
            <Text numberOfLines={1} style={styles.metaText}>
              {deliveryDate}
            </Text>
          </View>
          {!!delivery.instructions && (
            <View style={styles.metaRow}>
              <Feather name="file-text" size={12} color="#71717a" />
              <Text numberOfLines={1} style={styles.metaText}>
                {delivery.instructions}
              </Text>
            </View>
          )}
        </View>
      </View>
    </Card>
  );
}

const styles = StyleSheet.create({
  card: {
    borderRadius: 10,
    borderColor: '#e4e4e7',
    borderWidth: 1,
    elevation: 1,
    marginHorizontal: 12,
    marginVertical: 5,
    overflow: 'hidden',
  },
  container: {
    paddingHorizontal: 12,
    paddingVertical: 10,
    gap: 8,
  },
  headerRow: {
    flexDirection: 'row',
    alignItems: 'flex-start',
    justifyContent: 'space-between',
    gap: 8,
  },
  titleBlock: {
    flex: 1,
    minWidth: 0,
    gap: 3,
  },
  typeBadge: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 4,
    backgroundColor: '#eef2ff',
    borderRadius: 999,
    paddingHorizontal: 8,
    paddingVertical: 2,
    alignSelf: 'flex-start',
  },
  typeBadgeText: {
    color: '#6366f1',
    fontSize: 10,
    fontWeight: '700',
    textTransform: 'uppercase',
  },
  companyText: {
    color: '#18181b',
    fontSize: 14,
    fontWeight: '700',
    marginTop: 2,
  },
  rightActionRow: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 4,
    flexShrink: 0,
  },
  dateText: {
    color: '#71717a',
    fontSize: 11,
  },
  menuContainer: {
    marginRight: -4,
  },
  metaContainer: {
    gap: 4,
    marginTop: 2,
  },
  metaRow: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 6,
  },
  metaText: {
    color: '#52525b',
    fontSize: 12,
    flexShrink: 1,
  },
});
